import React from 'react';
import { Link } from 'react-router-dom';

const QUICK_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/services', label: 'Services' },
  { to: '/loans', label: 'Loan Products' },
  { to: '/about', label: 'About Us' },
  { to: '/contact', label: 'Contact' },
];

const SERVICES = [
  'Home Loans',
  'Education Loans',
  'Car Loans',
  'Loan Against Property',
  'SME / Business Loans',
  'Real Estate Consulting',
];

export const FooterQuickLinks = () => (
  <div>
    <h3 className="text-white font-bold mb-4">Quick Links</h3>
    <ul className="space-y-2 text-sm">
      {QUICK_LINKS.map(({ to, label }) => (
        <li key={to}>
          <Link to={to} className="hover:text-cyan-400 transition-colors">{label}</Link>
        </li>
      ))}
    </ul>
  </div>
);

export const FooterServices = () => (
  <div>
    <h3 className="text-white font-bold mb-4">Our Services</h3>
    <ul className="space-y-2 text-sm">
      {SERVICES.map((service) => (
        <li key={service} className="hover:text-cyan-400 transition-colors cursor-pointer">{service}</li>
      ))}
    </ul>
  </div>
);
